module.exports = __webpack_public_path__ + "static/media/bismillah.5848dd56.png";